<template>
  <v-layout row wrap>
    <v-flex xs12 class="pt-0">
      <button class="ch-floating-btn ch-menu-btn">
        <download-excel
          :fetch   = "fetchData"
          :fields = "json_fields"
          :meta   = "json_meta"
          type    = "csv"
          :name    = "filename">
          <a>Excel Export</a>
          <span><img class="excel-file-export" src="../../../assets/img/file-export.png"></span>
        </download-excel>
      </button>
      <v-data-table
        :headers="headers"
        :items="listItems"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="ch-table-list"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"
              class="text-xs-left"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
              :hidden = "header.isNormalAdmin"
            >
              {{ header.text }}
              <v-icon v-if="sortableList.includes(header.value)">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
           <td class="text-xs-left list-btn" width="3%">
            <router-link
              :to="{ name: 'auditLogsDetail', params: { id: props.item.time }}"
            ><i class="fas fa-search"></i></router-link>
          </td>
          <td class="text-xs-left" v-if="props.item.index !== null && props.item.index.domain_index" width="5%" :hidden = "checkAdminType()"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.index.domain_index }}</span><pre>{{ props.item.index.domain_index }}</pre></v-tooltip></td>
          <td class="text-xs-left" v-else width="5%">&mdash;</td>
          <td class="text-xs-left" v-if="props.item.domain !== null" width="7%" :hidden = "checkAdminType()"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.domain.domain_name }}</span><pre>{{ props.item.domain.domain_name }}</pre></v-tooltip></td>
          <td class="text-xs-left" v-else width="7%">&mdash;</td>
          <td class="text-xs-left" v-if="props.item.index !== null && props.item.index.hotel_index" width="5%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.index.hotel_index }}</span><pre>{{ props.item.index.hotel_index }}</pre></v-tooltip></td>
          <td class="text-xs-left" v-else width="5%">&mdash;</td>
          <td class="text-xs-left" v-if="props.item.hotel !== null" width="7%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.hotel.hotel_name }}</span><pre>{{ props.item.hotel.hotel_name }}</pre></v-tooltip></td>
          <td class="text-xs-left" v-else width="7%">&mdash;</td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.formatedTime }}</span><pre>{{ props.item.formatedTime }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="7%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.actor.actor_name }}</span><pre>{{ props.item.actor.actor_name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.actor.actor_email }}</span><pre>{{ props.item.actor.actor_email }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.action }}</span><pre>{{ props.item.action }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="20%"><v-tooltip bottom color="primary" ><span slot="activator">{{ displayedTarget(props.item.parsedTarget) }}</span><pre>{{ props.item.parsedTarget }}</pre></v-tooltip> </td>
          <td class="text-xs-left" v-if="props.item.location" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.location }}</span><pre>{{ props.item.location }}</pre></v-tooltip></td>
          <td class="text-xs-left" v-else width="5%">&mdash;</td>
          <td class="text-xs-left" v-if="props.item.consumer" width="7%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.consumer }}</span><pre>{{ props.item.consumer }}</pre></v-tooltip></td>
          <td class="text-xs-left" v-else width="5%">&mdash;</td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import moment from 'moment';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { auditLogsEventBus } from '@/components/admin/auditLogs/auditLogsEventBus';
  import Vue from 'vue';
  import JsonExcel from 'vue-json-excel';
  import api from '../../../api';

  Vue.component('downloadExcel', JsonExcel);

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        // NOTE: first init
        isInit: false,
        // NOTE: Table List
        loading: false,
        searchCategory: null,
        search: null,
        pagination: {
          sortBy: null,
          descending: null,
          rowsPerPage: 20,
        },
        totalItems: 0,
        visibleRoomName: false,
        headers: [
          { text: 'View', value: 'id', align: 'left', sortable: false },
          { text: 'Domain Index', value: 'domain_index', align: 'left', sortable: false, isNormalAdmin: this.checkAdminType() },
          { text: 'Domain', value: 'domain', align: 'left', sortable: false, isNormalAdmin: this.checkAdminType() },
          { text: 'Hotel Index', value: 'hotel_index', align: 'left', sortable: false },
          { text: 'Hotel', value: 'hotel', align: 'left', sortable: false },
          { text: 'Event Date & Time', value: 'time', align: 'left', sortable: false },
          { text: 'Operator Name', value: 'actor_name', align: 'left', sortable: false },
          { text: 'Operator Email', value: 'actor_email', align: 'left', sortable: false },
          { text: 'Event Type', value: 'action', align: 'left', sortable: false },
          { text: 'Object', value: 'target', align: 'left', sortable: false },
          { text: 'Location', value: 'location', align: 'left', sortable: false },
          { text: 'Application', value: 'consumer', align: 'left', sortable: false },
        ],
        rowsPerPageItems: [20, 50],
        sortableList: ['time'],
        // NOTE: Data
        listItems: [],    // 실제 서버에서 받아온 원본 리스트
        filter: [],       // 쿼리문을 담을 배열
        filename: `auditlog_${moment().format('YYYYMMDDHHmmss')}.xls`,
        json_fields: {
          'Domain Index': 'index.domain_index',
          Domain: 'domain.domain_name',
          'Hotel Index': 'index.hotel_index',
          Hotel: 'hotel.hotel_name',
          'Event Date & Time': 'parsedTime',
          'Operator Name': 'actor.actor_name',
          'Operator Email': 'actor.actor_email',
          'Event Type': 'action',
          Object: 'target',
          Location: 'location',
          Application: 'consumer',
        },
        json_meta: [
          [{
            key: 'charset',
            value: 'utf-8',
          }],
        ],
      };
    },
    methods: {
      /**
       * @description 상세 => 목록으로 넘어올 경우 필터값을 유지, 컴포넌트가 렌더링될 때 최초 한번만 실행
       */
      init() {
        if (_.isEmpty(this.storeFilter)) {
          this.getAuditLogList();
        }
      },
      /**
       * @description Audit 로그 목록 조회
       */
      getAuditLogList() {
        this.loading = true;
        let querystring = {};
        for (let index = 0; index < this.filter.length; index += 1) {
          querystring[this.filter[index].searchCategory] = this.filter[index].search;
        }
        if (querystring.startTime && querystring.endTime && querystring.startTime > querystring.endTime) {
          this.isBadRequestDate();
          return;
        }
        if (!querystring.startTime || !querystring.endTime) querystring = _.omit(querystring, ['startTime', 'endTime']);
        api.getAuditLogList(querystring)
        .then((result) => {
          if (result.status === 200) {
            this.listItems = result.data.map((item) => {
              const rebuildItem = item;
              rebuildItem.index = item.index ? item.index : null;
              rebuildItem.domain = item.domain ? item.domain : null;
              rebuildItem.hotel = item.hotel ? item.hotel : null;
              rebuildItem.consumer = this.parseConsumer(item.consumer);
              rebuildItem.parsedTarget = _.isString(item.target) ? JSON.parse(item.target) : item.target;
              rebuildItem.formatedTime = moment(rebuildItem.time).format('YYYY-MM-DD HH:mm:ss');
              return rebuildItem;
            });
            this.loading = false;
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data;
          this.alertOccur();
          this.loading = false;
        });
      },
      /**
       * @description target 문자열 파싱
       */
      displayedTarget(target) {
        let stringTarget = JSON.stringify(target);
        stringTarget = stringTarget.substring(1, stringTarget.length);
        stringTarget = stringTarget.substring(0, stringTarget.length - 1);
        stringTarget = this.replaceString(stringTarget, '{', '{ ');
        stringTarget = this.replaceString(stringTarget, '}', ' }');
        stringTarget = this.replaceString(stringTarget, '"|"', '');
        stringTarget = this.replaceString(stringTarget, ',', ', ');
        stringTarget = this.replaceString(stringTarget, ':', ': ');
        stringTarget = this.replaceString(stringTarget, '[[]', '[ ');
        stringTarget = this.replaceString(stringTarget, '[]]', ' ]');
        return stringTarget;
      },
      /**
       * @description consumer 문자열 파싱
       */
      parseConsumer(consumer) {
        if (_.includes(consumer, 'staff')) return 'StaffApp';
        return consumer;
      },
      /**
       * @description target 문자열 바꾸기
       */
      replaceString(str, pattern, replacement) {
        return _.replace(str, new RegExp(pattern, 'g'), replacement);
      },
      /**
       * @description 시작 날짜가 종료 날짜 보다 큰 경우 알림창 생성
       */
      isBadRequestDate() {
        this.alert.type = 'error';
        this.alert.color = 'red';
        this.alert.message = 'start date is bigger than end date.';
        this.alertOccur();
        this.loading = false;
      },
      /**
       * @description admin type이 root인지 normal인지 체크
       */
      checkAdminType() {
        return localStorage.getItem('domain_type') === 'normal';
      },
      /**
       * @description 오름차순/내림차순 정렬
       */
      changeSort(column) {
        if (this.sortableList.includes(column)) {
          if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
          } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
          }
        }
      },
      /**
       * @description 엑셀 Export 시 데이터를 파싱해서 가져오기
       */
      async fetchData() {
        const fetchData = await this.listItems.map((listItem) => {
          const parsedItem = listItem;
          parsedItem.parsedTime = JSON.stringify(listItem.formatedTime);
          return parsedItem;
        });
        return fetchData;
      },
    },
    watch: {
      pagination: {
        deep: true,
        handler() {
          if (this.isInit) {
            console.log('handler');
            this.getAuditLogList();
          }
        },
      },
    },
    computed: {
      pages() {
        /* eslint max-len: ["error", { "code": 200 }] */
        return this.pagination.rowsPerPage ? Math.ceil(this.listItems.length / this.pagination.rowsPerPage) : 0;
      },
    },
    mounted() {
      console.log('auditLoglist mount');
      this.init();
      // NOTE: 페이지 로드
      this.$nextTick(() => {
        this.isInit = true;
      });
      this.$nextTick(() => {
        if (!_.isEmpty(this.storePage)) {
          this.pagination = Object.assign({}, this.storePage);
          this.getAuditLogList();
        }
      });
      auditLogsEventBus.$on('initFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        this.getAuditLogList();
      });
      auditLogsEventBus.$on('customFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        this.pagination.page = 1;
        this.getAuditLogList();
      });
      auditLogsEventBus.$on('reloadList', () => this.getAuditLogList());
    },
    updated() {
      storeFilterEventBus.$emit('setPage', this.pagination);
    },
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/auditLogs/AuditLogsList.vue